import { Accordion, Button, TextInput } from 'flowbite-react';
import { useEffect, useState } from 'react';
import CommonApi from '../../Api/CommonApi';
import { ManualDisplay as ManualDisplayObj } from '../../Models/ManualDisplay';
import Loader from '../Common/Loader';
import { HiDownload } from 'react-icons/hi';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import ManufacturerApi from '../../Api/ManufacturerApi';
import { Manufacturer } from '../../Models/Manufacturer';
import { FileTypeEnums } from '../../Models/FileType';

export default function ManualPage() {
  const { id } = useParams();
  const [manufacturerData, setManufacturerData] =
    useState<Manufacturer | null>();
  const [manuals, setmanuals] = useState<ManualDisplayObj[] | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getManufacturer = () => {
    if (id) {
      setIsLoading(true);
      ManufacturerApi.getManufacturer(id)
        .then((res) => {
          setManufacturerData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setManufacturerData(null);
    }
  };

  useEffect(() => {
    getManufacturer();
    getManuals();
  }, [id]);

  const getManuals = () => {
    if (id) {
      setIsLoading(true);
      CommonApi.getManualsCustom(id)
        .then((res) => {
          if (res.data.length > 0) {
            setmanuals(res.data);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  return (
    <div className='w-full pt-4 h-[calc(100vh-60px)] md:h-[calc(100vh-130px)] overflow-y-auto '>
      <div className='flex flex-col mx-auto p-2'>
        <div className='mb-5 pb-5 border-b-2'>
          <h1 className='text-gray-900 font-bold text-4xl pr-10 mb-5'>
            {manufacturerData?.name} Manuals
          </h1>
          <div className=''>
            {manufacturerData?.files &&
              manufacturerData.files?.filter(
                (x) => x.fileTypeId === FileTypeEnums.Photo
              ).length > 0 && (
                <img
                  src={
                    manufacturerData.files.filter(
                      (x) => x.fileTypeId === FileTypeEnums.Photo
                    )[0].fileUrl!
                  }
                  className='h-24 object-contain float-left mx-5 my-2'
                />
              )}
            <div className='pr-0 lg:pr-10'>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    manufacturerData?.description ?? ''
                  ),
                }}
              />
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className=''>
            <div className='w-full overflow-y-auto'>
              {manuals && (
                <div className='w-full'>
                  {manuals
                    .filter(
                      (x) => x.manufacturerName === manufacturerData?.name
                    )
                    .map((category) => (
                      <div key={category.manufacturerName}>
                        {category.manualCategories?.map((sub) => (
                          <div key={sub.categoryName}>
                            <div className='font-bold text-xl'>
                              {sub.categoryName}
                            </div>
                            {sub?.manuals.map((man) => (
                              <a
                                key={man.fileName}
                                href={man.fileURL!}
                                download={man.fileName}
                              >
                                <button
                                  className='p-2 ml-4'
                                  style={{ color: 'blue' }}
                                >
                                  {man.fileName}
                                </button>
                              </a>
                            ))}
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
